import {
  PUBLIC_SHARE_URL_PATH,
  SHARE_URL_PATH,
} from "../constants/chat-share.constants";
import type { TExpiryPreset } from "../types/chat-share";

export interface IPresetToIsoParams {
  preset: TExpiryPreset;
  customDate: string;
}

export const presetToIso = ({
  preset,
  customDate,
}: IPresetToIsoParams): string | null => {
  const now = new Date();
  switch (preset) {
    case "never":
      return null;
    case "1d": {
      const d = new Date(now);
      d.setDate(d.getDate() + 1);
      return d.toISOString();
    }
    case "7d": {
      const d = new Date(now);
      d.setDate(d.getDate() + 7);
      return d.toISOString();
    }
    case "30d": {
      const d = new Date(now);
      d.setDate(d.getDate() + 30);
      return d.toISOString();
    }
    case "custom":
      return customDate
        ? new Date(`${customDate}T23:59:59`).toISOString()
        : null;
    default:
      return null;
  }
};

export interface IBuildChatShareUrlParams {
  // NOTE: Scheme + host with no trailing slash — `globalThis.location.origin` on
  // web, the configured web origin on mobile.
  origin: string;
  shareToken: string;
}

// NOTE: Both clients hand out the same URL, so a link created on a phone opens
// the web viewer the recipient already knows. The origin is the caller's because
// only it knows where its own app is served from.
export const buildChatShareUrl = ({
  origin,
  shareToken,
}: IBuildChatShareUrlParams): string =>
  `${origin.replace(/\/+$/, "")}${SHARE_URL_PATH}${shareToken}`;

// NOTE: NSAI-5823 — the public (no-account) viewer URL. Same shape as
// buildChatShareUrl but a different path: that link opens a page for a signed-in
// viewer, this one a password prompt.
export const buildChatPublicShareUrl = ({
  origin,
  shareToken,
}: IBuildChatShareUrlParams): string =>
  `${origin.replace(/\/+$/, "")}${PUBLIC_SHARE_URL_PATH}${shareToken}`;
